import React, { useEffect, useState } from 'react';
import api from '../lib/api';
import { kr } from '../lib/format';
import { PageHeader, Card, Modal } from '../components/ui';
import { Plus, Pencil, Trash2, Search } from 'lucide-react';

const tom = () => ({ navn: '', beskrivelse: '', enhetspris: 0, mva_sats: 25, enhet: 'stk',
  er_vare: false, kostpris: 0, min_lager: 0, lager_konto: '1460' });

const Produkter = () => {
  const [liste, setListe] = useState(null);
  const [sok, setSok] = useState('');
  const [open, setOpen] = useState(false);
  const [redigerer, setRedigerer] = useState(null);
  const [skjema, setSkjema] = useState(tom());

  const last = () => api.get('/produkter').then((r) => setListe(r.data));
  useEffect(() => { last(); }, []);

  const aapne = (p) => { setRedigerer(p); setSkjema(p ? { ...p } : tom()); setOpen(true); };
  const lagre = async () => {
    if (redigerer) await api.put(`/produkter/${redigerer.id}`, skjema);
    else await api.post('/produkter', skjema);
    setOpen(false); last();
  };
  const slett = async (p) => {
    if (!window.confirm(`Slett ${p.navn}?`)) return;
    await api.delete(`/produkter/${p.id}`); last();
  };

  if (!liste) return <span className="fm-text-muted">Laster…</span>;

  return (
    <>
      <PageHeader
        title="Produkter & tjenester"
        actions={<button className="btn-primary" onClick={() => aapne(null)}><Plus size={14} /> Nytt produkt</button>}
      />
      <Card style={{ marginBottom: 12 }}>
        <div style={{ position: 'relative', maxWidth: 360 }}>
          <Search size={14} style={{ position: 'absolute', left: 10, top: '50%',
                                     transform: 'translateY(-50%)', opacity: 0.55 }} />
          <input value={sok} onChange={(e) => setSok(e.target.value)}
                 placeholder="Søk navn eller beskrivelse…"
                 style={{ paddingLeft: 32, width: '100%' }} />
        </div>
      </Card>
      <Card style={{ padding: 0 }}>
        <table>
          <thead>
            <tr>
              <th>Navn</th><th>Beskrivelse</th><th>Enhet</th>
              <th style={{ textAlign: 'right' }}>Pris</th>
              <th style={{ textAlign: 'right' }}>MVA %</th>
              <th style={{ width: 80 }}></th>
            </tr>
          </thead>
          <tbody>
            {liste.length === 0 && (
              <tr><td colSpan={6} className="fm-text-muted" style={{ textAlign: 'center', padding: 20 }}>Ingen produkter enda.</td></tr>
            )}
            {liste.filter((p) => {
              if (!sok.trim()) return true;
              const q = sok.toLowerCase();
              return [p.navn, p.beskrivelse, p.enhet]
                .some((v) => (v || '').toString().toLowerCase().includes(q));
            }).map((p) => (
              <tr key={p.id}>
                <td>{p.navn}</td>
                <td>{p.beskrivelse}</td>
                <td>{p.enhet}</td>
                <td style={{ textAlign: 'right' }}>{kr(p.enhetspris)}</td>
                <td style={{ textAlign: 'right' }}>{p.mva_sats}</td>
                <td>
                  <div className="flex" style={{ gap: 4 }}>
                    <button className="btn-ghost" onClick={() => aapne(p)}><Pencil size={12} /></button>
                    <button className="btn-ghost" onClick={() => slett(p)} style={{ color: 'var(--theme-danger)' }}><Trash2 size={12} /></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>

      <Modal open={open} onClose={() => setOpen(false)} title={redigerer ? 'Rediger produkt' : 'Nytt produkt'}
             footer={<>
               <button className="btn-ghost" onClick={() => setOpen(false)}>Avbryt</button>
               <button className="btn-primary" onClick={lagre}>Lagre</button>
             </>}>
        <div className="grid" style={{ gridTemplateColumns: '1fr 1fr', gap: 10 }}>
          <div style={{ gridColumn: '1 / -1' }}><label>Navn *</label><input value={skjema.navn} onChange={(e) => setSkjema({...skjema, navn: e.target.value})} /></div>
          <div style={{ gridColumn: '1 / -1' }}><label>Beskrivelse</label><textarea value={skjema.beskrivelse} onChange={(e) => setSkjema({...skjema, beskrivelse: e.target.value})} /></div>
          <div><label>Enhetspris</label><input value={skjema.enhetspris} onChange={(e) => setSkjema({...skjema, enhetspris: e.target.value})} /></div>
          <div>
            <label>MVA-sats (%)</label>
            <select value={skjema.mva_sats} onChange={(e) => setSkjema({...skjema, mva_sats: parseFloat(e.target.value)})}>
              <option value={25}>25</option><option value={15}>15</option>
              <option value={12}>12</option><option value={0}>0</option>
            </select>
          </div>
          <div>
            <label>Enhet</label>
            <select value={skjema.enhet} onChange={(e) => setSkjema({...skjema, enhet: e.target.value})}>
              <option value="stk">stk</option><option value="time">time</option>
              <option value="m">m</option><option value="kg">kg</option>
            </select>
          </div>
          <div style={{ gridColumn: '1 / -1', borderTop: '1px solid var(--theme-border)', paddingTop: 8 }}>
            <label style={{ display: 'inline-flex', alignItems: 'center', gap: 6, margin: 0 }}>
              <input type="checkbox" checked={!!skjema.er_vare}
                     onChange={(e) => setSkjema({...skjema, er_vare: e.target.checked})} />
              Følg lagerbeholdning (vare, ikke tjeneste)
            </label>
          </div>
          {skjema.er_vare && <>
            <div><label>Kostpris</label>
              <input type="number" step="0.01" value={skjema.kostpris}
                     onChange={(e) => setSkjema({...skjema, kostpris: e.target.value})} /></div>
            <div><label>Min. beholdning</label>
              <input type="number" step="0.01" value={skjema.min_lager}
                     onChange={(e) => setSkjema({...skjema, min_lager: e.target.value})} /></div>
            <div><label>Lagerkonto</label>
              <input value={skjema.lager_konto || '1460'}
                     onChange={(e) => setSkjema({...skjema, lager_konto: e.target.value})} /></div>
          </>}
        </div>
      </Modal>
    </>
  );
};

export default Produkter;
